import { useListStore } from '../../hooks';
import { CrawlerListView } from '../../components/CrawlerListView';

export const CrawlerList = () => {
  const { crawlers, onOpenModal } = useListStore();

  return (
    <CrawlerListView listItems={crawlers} handleOpenDetailModal={onOpenModal} />
  );
};
